function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { transparentize } from 'polished';
import { useTranslation } from 'react-i18next';
import { Label, Checkbox, Input, TitleComponent } from '@keen.io/ui-core';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { CardWrapper, StepContainer, StepHeader, StepTitle, IconContainer, Settings, HintHighlight, Clone, Close, Wrapper, Item, SmallItem, StepName, Incomplete } from './FunnelStep.styles';
import EventCollection from '../EventCollection';
import TargetProperty from '../TargetProperty';
import Timeframe from '../Timeframe';
import Hint from '../Hint';
import Filters from '../Filters';
import { updateFunnelStep, updateFunnelStepTimezone, selectFunnelStepCollection, addFunnelStepFilter, updateFunnelStepFilter, removeFunnelStepFilter } from '../../modules/query';

var FunnelStep = function FunnelStep(_ref) {
  var index = _ref.index,
      id = _ref.id,
      eventCollection = _ref.eventCollection,
      actorProperty = _ref.actorProperty,
      timeframe = _ref.timeframe,
      timezone = _ref.timezone,
      optional = _ref.optional,
      inverted = _ref.inverted,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      detailsVisible = _ref.detailsVisible,
      isFirstStep = _ref.isFirstStep,
      isDragged = _ref.isDragged,
      _ref$stepLabel = _ref.stepLabel,
      stepLabel = _ref$stepLabel === void 0 ? '' : _ref$stepLabel,
      onRemove = _ref.onRemove,
      setDetailsVisible = _ref.setDetailsVisible,
      onClone = _ref.onClone,
      onLabelChange = _ref.onLabelChange;
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var firstDetailsVisible = useRef(detailsVisible);
  var updateStep = useCallback(function (step) {
    return dispatch(updateFunnelStep(id, step));
  }, [id]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  useEffect(function () {
    firstDetailsVisible.current && !detailsVisible && setError(eventCollection === undefined || actorProperty === undefined);
  }, [eventCollection, actorProperty, detailsVisible]);
  return React.createElement(StepContainer, {
    isDragged: isDragged
  }, React.createElement(CardWrapper, {
    className: "dragBar",
    "data-testid": "bar",
    onClick: function onClick() {
      return setDetailsVisible(detailsVisible ? null : id);
    }
  }, React.createElement(StepHeader, null, React.createElement(IconContainer, null, React.createElement(Icon, {
    type: detailsVisible ? 'caret-down' : 'caret-right',
    fill: transparentize(0.3, colors.black[100])
  })), React.createElement(StepTitle, {
    hasError: error
  }, t('query_creator_funnel_step.title'), " ", index + 1, error && React.createElement(Incomplete, null, "(incomplete)"), React.createElement(StepName, null, stepLabel || eventCollection)), React.createElement(Settings, null, React.createElement(Clone, {
    "data-testid": "clone-button",
    onClick: function onClick(e) {
      e.stopPropagation();
      onClone(id);
    }
  }, t('query_creator_funnel_step.clone')), React.createElement(Close, {
    "data-testid": "close-button",
    onClick: function onClick(e) {
      e.stopPropagation();
      onRemove();
    }
  }, React.createElement(Icon, {
    type: "close",
    fill: colors.red[200]
  }))))), detailsVisible && React.createElement(CardWrapper, null, React.createElement(Wrapper, null, React.createElement(Item, null, React.createElement(EventCollection, {
    hasError: !eventCollection && error,
    variant: "secondary",
    collection: eventCollection,
    onChange: function onChange(collection) {
      dispatch(selectFunnelStepCollection(collection));
      updateStep({
        eventCollection: collection,
        actorProperty: undefined,
        filters: []
      });
    }
  })), React.createElement(Item, null, React.createElement(TargetProperty, {
    hasError: !actorProperty && error,
    variant: "secondary",
    collection: eventCollection,
    property: actorProperty,
    onChange: function onChange(property) {
      property && dispatch(updateStep({
        actorProperty: property
      }));
    }
  })), React.createElement(Item, null, React.createElement(Timeframe, {
    id: "timeframe",
    value: timeframe,
    timezone: timezone,
    variant: "secondary",
    onTimeframeChange: function onTimeframeChange(timeframe) {
      return dispatch(updateStep({
        timeframe: timeframe
      }));
    },
    onTimezoneChange: function onTimezoneChange(timezone) {
      dispatch(updateStep({
        timezone: timezone
      }));
      dispatch(updateFunnelStepTimezone(id, timezone));
    }
  }))), React.createElement(Wrapper, {
    display: "block"
  }, React.createElement(Filters, {
    funnelStepId: id,
    collection: eventCollection,
    filters: filters,
    onRemove: function onRemove(filterId) {
      return dispatch(removeFunnelStepFilter(id, filterId));
    },
    onChange: function onChange(filterId, filter) {
      return dispatch(updateFunnelStepFilter(id, filterId, filter));
    },
    onClick: function onClick(filterId) {
      return dispatch(addFunnelStepFilter(id, filterId));
    }
  })), React.createElement(Wrapper, null, React.createElement(Item, null, React.createElement(TitleComponent, null, t('query_creator_funnel_step.step_label')), React.createElement(Input, {
    type: "text",
    variant: "solid",
    id: "stepName-".concat(id, "-").concat(index),
    placeholder: eventCollection && eventCollection,
    onChange: function onChange(e) {
      onLabelChange && onLabelChange(e.target.value, index);
    },
    value: stepLabel
  })), React.createElement(SmallItem, null, React.createElement(Label, {
    disabled: isFirstStep,
    htmlFor: "optional-step-".concat(index)
  }, React.createElement(Checkbox, {
    type: "secondary",
    id: "optional-step-".concat(index),
    onChange: function onChange() {
      return updateStep({
        optional: !optional
      });
    },
    checked: !isFirstStep && optional,
    disabled: isFirstStep
  }), t('query_creator_funnel_step.optional_label')), React.createElement(Hint, {
    type: "info",
    message: isFirstStep ? React.createElement(React.Fragment, null, t('query_creator_funnel_step.optional_tooltip'), React.createElement(HintHighlight, null, t('query_creator_funnel_step.first_step_optional_tooltip'))) : t('query_creator_funnel_step.optional_tooltip'),
    fill: colors.blue[500],
    height: 16,
    width: 16
  })), React.createElement(SmallItem, null, React.createElement(Label, {
    disabled: isFirstStep,
    htmlFor: "inverted-step-".concat(index)
  }, React.createElement(Checkbox, {
    type: "secondary",
    id: "inverted-step-".concat(index),
    onChange: function onChange() {
      return updateStep({
        inverted: !inverted
      });
    },
    checked: !isFirstStep && inverted,
    disabled: isFirstStep
  }), t('query_creator_funnel_step.inverted_label')), React.createElement(Hint, {
    type: "info",
    message: isFirstStep ? React.createElement(React.Fragment, null, t('query_creator_funnel_step.inverted_tooltip'), React.createElement(HintHighlight, null, t('query_creator_funnel_step.first_step_inverted_tooltip'))) : t('query_creator_funnel_step.inverted_tooltip'),
    fill: colors.blue[500],
    height: 16,
    width: 16
  })))));
};

export default FunnelStep;